import React, { useMemo } from 'react';
import Icon from '../ui/Icon';
import './MotivationMoment.css';

// Contextual quotes, never random. Each context has a small fixed pool so a
// session doesn't feel repetitive; picked deterministically from `seed` (an
// id from the triggering event, e.g. an attempt id) so the same moment always
// shows the same line rather than flickering between renders.
const POOLS = {
  post_difficult_result: [
    "One test doesn't define you. Find the mistake. Fix it. Come back stronger.",
    "A rough result is just today's data point — not your ceiling.",
  ],
  post_completion: [
    "Good work. Now turn today's mistakes into tomorrow's strengths.",
    "Done is progress. Come back and build on it.",
  ],
  mistake_review: [
    "Understanding one mistake is better than repeating ten.",
    "Every mistake you understand is one less mistake you'll make again.",
    "Understanding the mistake is the real win.",
  ],
  recovery: [
    "Recovered. That's progress.",
    "That mistake won't catch you again.",
  ],
  streak: [
    "Consistency beats intensity.",
    "Small, regular reps are what actually move the needle.",
  ],
  improvement: [
    "You just proved that practice changes performance.",
    "That's a real gain — not luck, not a guess. Keep going.",
    "You're getting harder questions right.",
  ],
  before_assessment: [
    "Preparation beats panic.",
    "You've done the work — now show it.",
  ],
  batch_movement: [
    "You're moving up.",
    "That climb is real, earned progress.",
  ],
  assessment_complete: [
    "Another checkpoint cleared.",
    "One more real data point in your favor.",
  ],
};

const MotivationMoment = ({ context, seed = '' }) => {
  const pool = POOLS[context];
  const line = useMemo(() => {
    if (!pool || pool.length === 0) return null;
    let hash = 0;
    for (let i = 0; i < String(seed).length; i++) hash = (hash * 31 + String(seed).charCodeAt(i)) >>> 0;
    return pool[hash % pool.length];
  }, [pool, seed]);

  if (!line) return null;

  return (
    <div className="z-motivation-moment">
      <span className="z-motivation-icon" aria-hidden="true"><Icon name="sparkle" size={20} /></span>
      <p>{line}</p>
    </div>
  );
};

export default MotivationMoment;
